export default "__VITE_ASSET__BwOPjFgS__"